// extracted by mini-css-extract-plugin
export default {"section":"trademark_notices_section__Q7-Bz","section_body":"trademark_notices_section_body__yDnjH"};